var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switcher"},_vm._l((_vm.locales),function(locale){return _c('div',{key:locale.key,on:{"click":function($event){_vm.setLocale(locale)}}},[_c('img',{staticClass:"flag",class:{ active: locale.key == _vm.$i18n.locale },attrs:{"src":_vm.getFlagPath(locale),"alt":_vm.getAltText(locale)}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0867b6ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSwitcher.vue
// module id = null
// module chunks = 